import { Component, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as L from 'leaflet';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrl: './map.component.css',
})
export class MapComponent implements OnInit, OnDestroy {
  @Input() public darReference?: string | null;
  @ViewChild('mapEl', { static: true }) private readonly mapEl!: ElementRef<HTMLDivElement>;

  private map?: L.Map;
  private readonly http = inject(HttpClient);

  public ngOnInit(): void {
    if (!this.darReference) return;

    const adresseUrl = `https://api.dataforsyningen.dk/adresser/${this.darReference}?format=json`;
    const adgangsadresseUrl = `https://api.dataforsyningen.dk/adgangsadresser/${this.darReference}?format=json`;

    this.http.get<any>(adresseUrl).pipe(
      catchError(() => this.http.get<any>(adgangsadresseUrl).pipe(
        catchError(() => EMPTY)
      ))
    ).subscribe(data => {
      const coords = data?.adgangsadresse?.adgangspunkt?.koordinater
        ?? data?.adgangspunkt?.koordinater;

      if (!coords) return;
      this.renderMap(coords[1], coords[0]);
    });
  }

  public ngOnDestroy(): void {
    this.map?.remove();
  }

  private renderMap(lat: number, lon: number): void {
    const el = this.mapEl.nativeElement;

    const map = L.map(el, {
      center: [lat, lon],
      zoom: 17,
      scrollWheelZoom: false,
      attributionControl: false,
    });
    this.map = map;

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    }).addTo(map);

    L.marker([lat, lon]).addTo(map);

    el.addEventListener('wheel', (e: WheelEvent) => {
      if (!e.ctrlKey) return;
      e.preventDefault();
      if (e.deltaY < 0) map.zoomIn();
      else map.zoomOut();
    }, { passive: false });
  }
}
